define("shared/components/shared/post/secondary/hashtag-suggestions/search-upgrade-modal", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <section class="o--modalBody--secondary u--p__0 has--footer">
    <div class="cMH--blank">
      <Shared::Post::Secondary::HashtagSuggestions::UpgradeModalBackground />
  
      <div class="cMH--blank__overlay">
  
        {{#if this.isMobileSubscription}}
          <Shared::Post::Secondary::HashtagSuggestions::MobileUpgrade />
        {{else}}
          {{! Auto Hashtags }}
          <label class="cMH--upgradeCard">
            <div class="cMH--upgradeCard__input">
              <div class="u--block">
                <p class="u--text--bold u--m__b__xs qa--autoHashtagOption">
                  {{t "hashtag_suggestions.limited.upgrade_modal_free.button.header"}}
                </p>
                <p class="u--m__b__0">{{t "hashtag_suggestions.limited.upgrade_modal_free.button.detail"}}</p>
              </div>
            </div>
            <Shared::Post::Secondary::HashtagSuggestions::SearchUpgradeModalDetails @planName={{this.planName}} />
          </label>
        {{/if}}
  
      </div>
    </div>
  </section>
  */
  {
    "id": "KZPPCfVS",
    "block": "[[[10,\"section\"],[14,0,\"o--modalBody--secondary u--p__0 has--footer\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cMH--blank\"],[12],[1,\"\\n    \"],[8,[39,0],null,null,null],[1,\"\\n\\n    \"],[10,0],[14,0,\"cMH--blank__overlay\"],[12],[1,\"\\n\\n\"],[41,[30,0,[\"isMobileSubscription\"]],[[[1,\"        \"],[8,[39,2],null,null,null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"label\"],[14,0,\"cMH--upgradeCard\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"cMH--upgradeCard__input\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"u--text--bold u--m__b__xs qa--autoHashtagOption\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"hashtag_suggestions.limited.upgrade_modal_free.button.header\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,3],[\"hashtag_suggestions.limited.upgrade_modal_free.button.detail\"],null]],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,4],null,[[\"@planName\"],[[30,0,[\"planName\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"shared/post/secondary/hashtag-suggestions/upgrade-modal-background\",\"if\",\"shared/post/secondary/hashtag-suggestions/mobile-upgrade\",\"t\",\"shared/post/secondary/hashtag-suggestions/search-upgrade-modal-details\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/search-upgrade-modal.hbs",
    "isStrictMode": false
  });
  let SearchUpgradeModalComponent = _exports.default = (_class = class SearchUpgradeModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get planName() {
      return this.intl.t('plans.plan_names.starter202506');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SearchUpgradeModalComponent);
});